export function nullableSet<T>(values: T[] | undefined): Set<T> | undefined {
  if (values === undefined) return undefined
  return new Set(values)
}
